import React from 'react';
import { PlayerStastisticInfo } from '../playerStastisticInfo';
import { PlayerStatistics } from '@base/features/user/model/interfaces';
import Tooltip, { TooltipPlacement } from '@ui-kit/components/tooltip';

export default function PopoverPlayerStastisticInfo(props: {
  player: PlayerStatistics;
  placement?: TooltipPlacement;
  children?: React.ReactElement;
}) {
  return (
    <Tooltip
      overlay={<PlayerStastisticInfo player={props.player} />}
      trigger="click"
      placement={props.placement || 'bottom'}
    >
      {props.children}
    </Tooltip>
  );
}
